module.exports = __webpack_public_path__ + "media/images/iconTrend--same-2057e5ebbe89d1c4e4d4b3253062e532.png";